export const messageListLabel = "hmQIxc";
export const skipToMessageList = "BiQg3c";
export default {messageListLabel,skipToMessageList};